import { useState } from 'react';
import { DatePicker, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useLazyExportTurnoverXlsxQuery, useTurnoverReportQuery } from '@/entities/reports';
import type { TurnoverReportRow } from '@/entities/reports';
import { ReportPage } from '@/shared/ui';
import { useStoreContext } from '@/shared/lib/store-context';
import { todayInTz } from '@/shared/lib/date';

/** §13: обороты по категориям за период (stock_movements). */
export function TurnoverReportPage() {
  const ctx = useStoreContext();
  const today = todayInTz(ctx.timezone);
  const [from, setFrom] = useState(dayjs(today).startOf('month').format('YYYY-MM-DD'));
  const [to, setTo] = useState(today);
  const { data, isFetching } = useTurnoverReportQuery({ from, to }, { pollingInterval: 30_000 });
  const [exportXlsx] = useLazyExportTurnoverXlsxQuery();

  const columns: ColumnsType<TurnoverReportRow> = [
    { title: 'Товар', dataIndex: 'categoryName' },
    { title: 'Остаток на начало', dataIndex: 'openingQty', width: 140, align: 'right' },
    { title: 'Приход за период', dataIndex: 'incomingQty', width: 140, align: 'right' },
    { title: 'Расход за период', dataIndex: 'outgoingQty', width: 140, align: 'right' },
    { title: 'Остаток на конец', dataIndex: 'closingQty', width: 140, align: 'right' },
    { title: '', width: 120, render: (_v, r) => (r.recalcPending ? <Tag color="processing">пересчитывается</Tag> : null) },
  ];

  return (
    <ReportPage
      title="Обороты"
      filters={
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          value={[dayjs(from), dayjs(to)]}
          onChange={(dates) => {
            if (dates && dates[0] && dates[1]) {
              setFrom(dates[0].format('YYYY-MM-DD'));
              setTo(dates[1].format('YYYY-MM-DD'));
            }
          }}
        />
      }
      columns={columns}
      data={data?.rows ?? []}
      loading={isFetching}
      rowKey="categoryId"
      onExport={() => exportXlsx({ from, to }).unwrap()}
      exportFilename="Обороты.xlsx"
    />
  );
}
